module.exports = __webpack_public_path__ + "img/laporan-alt.fdab5432.svg";